export default __webpack_public_path__ + "static/media/v-20.dc42631f.svg";